export default {
  "common": {
    "p2": "HOME",
    "p3": "EVENTS",
    "p4": "PPWC",
    "p5": "PPPoker Festival",
    "p6": "BLOG",
    "p7": "FAQ",
    "p8": "Account Settings",
    "p9": "Clubs & Unions",
    "p10": "Data Management",
    "p11": "Shop",
    "p12": "Lobby & Global Tournaments",
    "p13": "Hand Review & Forum",
    "p14": "Push Notifications",
    "p15": "Features",
    "p16": "Language",
    "p17": "English",
    "p18": "Português",
    "p19": "Русский",
    "p20": "Español",
    "p21": "Contact Us",
    "p22": "SUBSCRIBE TO OUR NEWSLETTER",
    "p23": "SUBMIT",
    "p24": "About Us",
    "p25": "PPPoker Logo Guidelines",
    "p26": "Privacy Policy",
    "p27": "Terms of Service",
    "p28": "Community Rules",
    "p29": "Unsolicited Ideas",
    "p30": "Copyright © 2015-{year} PPPoker. All Rights Reserved.",
    "p31": "Thank you!",
    "p32": "Thank you for subscribing to our newsletter!",
    "p33": "You will receive updates with our latest news, promotions and special offers!",
    "p34": "Best Regards",
    "p35": "the PPPoker Team",
    "p36": "WE ARE PLAYING PPPOKER",
    "p37": "Learn More",
    "p38": "More",
    "p39": "Close",
    "p40": "RUN YOUR OWN POKER CLUB",
    "p41": "PPPoker’s unique model brings poker back to the people!",
    "p42": "Create your own private PPPoker Club and run your own MTT, SNG and ring games! ",
    "p43": "Enjoy online poker with friends, with control over who joins your Club. Or join a Union and share player pools with other clubs across your region!",
    "p44": "DIVERSE POKER EXPERIENCES",
    "p45": "Our continuous development journey aims to create the best in online poker for YOU!",
    "p46": "Come play in our Global Tournaments section! Compete for gifts, tech prizes, live game tickets and more!",
    "p47": "Check out all the game types in our Lobby and get playing in seconds!",
    "p48": "EXCITING POKER FORMATS",
    "p49": "We celebrate the variety in poker, so offer the best and latest variants of the legendary game.",
    "p50": "At the heart of our offering you will find the classic and enduring game of No Limit Texas Hold’em, as well as the newly popular 6+ variant!",
    "p51": "We run the ever popular action-packed and classic 4 card Pot Limit Omaha games, as well as an exciting 5 card variant!",
    "p52": "We are one of the biggest go-to sites in the world for Pineapple Open Face Chinese Poker! Featuring a number of thrilling variants including Aggressive, Ultimate and Joker modes.",
    "p53": "LEARN & IMPROVE IN OUR POKER COMMUNITY",
    "p54": "We are very proud of the PPPoker community, and keep this at the heart of our vision.",
    "p55": "Thousands of Poker Clubs choose to make PPPoker their home, and this makes for a very special sense of camaraderie, sportsmanship and a thriving dynamic to every game.",
    "p56": "Our PPWC and PPPoker Festival events are booming, and we’re adding stops every year. Look out for our next event near you!",
    "p57": "Learn and improve your poker skills in the Forum with hundreds of excellent poker hands uploaded everyday!",
    "p58": "Upcoming",
    "p59": "To be announced...",
    "p60": "Past Events",
    "p61": "Report",
    "p62": "Result",
    "p63": "PPWC Report",
    "p64": "About PPWC",
    "p65": "Time",
    "p66": "Event#",
    "p67": "Name",
    "p68": "Buy-in (PHP)",
    "p69": "Tournament Info",
    "p70": "Details",
    "p71": "Results",
    "p72": "Upcoming",
    "p73": "About PPPoker Festival",
    "p74": "Tournament Info",
    "p75": "Date",
    "p76": "Buy-in",
    "p77": "Prize Pool",
    "p78": "Location",
    "p79": "Schedule",
    "p80": "Tournament Structure",
    "p81": "Past Events",
    "p82": "Most Popular",
    "p83": "Was this helpful for you?",
    "p84": "FOLLOW US",
    "p85": "NEW MULTI-TABLE ACTION",
    "p86": "At PPPoker, we know our players love action, so we've gone beyond one table per device!",
    "p87": "With our new multi-table feature, you can now play up to three tables at a time, all from your mobile phone! Triple the action, triple the fun!\r\n",
    "p88": "Tables are highlighted automatically as soon as it’s your turn, making it a breeze to swipe to the next piece of action.",
    "p89": "With our VIP service rival data details, you’ll gather in-table information on your opponents’ strategies even while looking at another table.",
    "p90": "A FAIR AND SAFE PLATFORM FOR ALL",
    "p91": "At PPPoker we take fair play seriously, and work hard to keep our platform free from cheats.",
    "p92": "We employ a dedicated team made up of data analysts and pro poker players to monitor our tables for any suspicious activity. ",
    "p93": "We have an anti-bot system in place which uses over fifty unique indicators to detect and prevent bots, as well as third party software.",
    "p94": "PPPoker takes a zero-tolerance approach to unfair play, and will permanently ban accounts found to be in violation. Enjoy a fair, safe game at PPPoker today!",
    "p95": "Loading…",
    "p96": "Introduction",
    "p97": "Venue",
    "p98": "Keep in the Loop!",
    "p99": "We'd like to share our latest product updates and promotions with you!",
    "p100": "Your Email",
    "p101": "Subscribe",
    "p102": "I don't want to see this anymore.",
    "p103": "No spam. We promise!",
    "p104": "*Please enter a valid email address!",
    "p105": "Share",
    "p106": "404 NOT FOUND",
    "p107": "Sorry, but the page that you request doesn't exist",
    "p108": "Back Home",
    "p109": "We use cookies to give you the best browsing experience. By using our website, you agree to our {link}.",
    "p110": "Agree",
    "p111": "Cookie Notice",
    "p112": "Public Relationship"
  },
  "about": {
    "p2": "About PPPoker",
    "p3": "Our motto is \"For Poker Lovers, By Poker Lovers\" - here at PPPoker we strive to provide a safe and fair gaming platform for all poker enthusiasts.",
    "p4": "Launched in 2016, PPPoker has continued to offer the best poker experience to millions of real players from over 100 countries worldwide.",
    "p5": "With PPPoker you can play poker anytime, anywhere with your friends by creating your own club or by jumping into Global Tournaments to compete with players across the world. Choose your favorite poker games from our popular options of No Limit Hold'em, Pot Limit and Five Card Omaha, Open Face Chinese Poker and more! Customize your own ring games and tournaments, throw in some insurance, or add a jackpot. Enjoy the poker you love on PPPoker!",
    "p6": "Contact Us",
    "p7": "For Customer Service:",
    "p8": "Please contact: {link}",
    "p9": "For Branding Cooperation:"
  },
  "brand": {
    "p2": "Download",
    "p3": "PPPoker Logo Guidelines",
    "p4": "1. MASTER BRAND LOGO",
    "p5": "The logo versions shown below demonstrate proper usage on a dark background. Whenever possible, the two spot color logos are preferred in all communication materials.",
    "p6": "Vertical",
    "p7": "Horizonal",
    "p8": "When it is not possible to show the logo on a solid dark background the logos are available in green type.",
    "p9": "2. PLANAR BRAND LOGO",
    "p10": "The green spade icon in PPPoker master logos should be shown as stereoscopic. However in any instances when this does not work, the logo with plane graph may be used as shown below:",
    "p11": "Reversed Logo",
    "p12": "In the event that a one-color version is required, utilize the white\r\nreversed logo. Green background is preferred.",
    "p13": "3. WEBSITE LOGO",
    "p14": " This set of logo with website link should only be used in some\r\r\noccasions. Please consult PPPoker Branding Team when you would\r\r\nlike to use this series. {link}",
    "p15": "4. LOGO USAGE GUIDE",
    "p16": "Keep The Logo Exactly As It Is",
    "p17": "DO NOT distort, stretch, adapt, remake, change colours or logo placement and do not add on to the logo.",
    "p18": "Do Not Pixelate The Logo",
    "p19": "Never use logo with low resolution which reveals artifacting, and do a print check if necessary to ensure art edges are crisp and sharp.",
    "p20": "Ensure Enough Breathing Room For The Logo",
    "p21": "The minimum required space around all logos is defined by the height of the \"P\" in the PPPoker name.",
    "p22": "5. LOGO MINIMUM SIZE",
    "p23": "The minimum size for the master logo should be as shown below:",
    "p24": "6. OFFICIAL COLOR CODE",
    "p25": "At the core of PPPoker brand is our signature colour GREEN.",
    "p26": "CMYK conversion should be utilized for all print materials. RGB conversion should be utilized for on-screen/web/digital applications.",
    "p27": "7. GRAPHIC DEVICE",
    "p28": "The green spade icon may be used as a graphic device for any brand materials of PPPoker.",
    "p29": "The brand icon should not be used in isolation when referring to the brand logo except when there is insufficient space to use the full logo. In this case, the green spade should only be placed within the green round-cornered rectangular background as shown below.",
    "p30": "8. PPPOKER BRAND NAME",
    "p31": "The PPPoker name should always be written as one word with three capital \"P\"s as in PPPoker.",
    "p32": "9. TRADEMARK USE REQUEST",
    "p33": "We're proud of PPPoker logos and care about our brand that they represent. We generally permit our partners to use our logo, however we do have some basic rules to ensure our logo is not misused or misrepresented.\r\n",
    "p34": "If you would like to access our logos for approved use, please send your logo use application to {link} at least 7 days in advance of any intended use.",
    "p35": "Your logo use application need to specify the applicant and the organization name, purpose of usage, logo position on material, duration of use and any other details we may deem fit."
  },
  "event": {
    "p2": "The PPWC (PPPoker World Championship) is an international poker tournament series proudly brought to you by PPPoker. It is our goal to bring the camaraderie and sense of community seen amongst the users of our app to the global live poker stage, and offer a compelling line-up of fantastic live poker tournaments for our players at every stop in our never-ending PPWC tour. ",
    "p3": "As well as a multi-day Main Event with a great structure, we are offering a uniquely attractive special event in keeping with our love of the poker community - namely our Team Event, in which teams of six members of the same nationality may compete against a roster of up to twenty teams in total, in a true test of international poker skill.",
    "p4": "At PPPoker we have our roots in the ongoing success of our social poker app, and our mission is to bring the same sense of community to the live poker scene. We have successfully hosted PPPoker Festivals in the Philippines, Japan, Brazil, India, Australia and Taiwan, and we plan to build on this success with many more events! \r\n\r\n",
    "p5": "The PPPoker Festival aims to offer players the chance to turn their poker chips into a lifelong worldwide poker adventure. We want to give our players the opportunity to live the dream of travelling around the world playing poker. "
  },
  "faq": {
    "p1": "Tutorial",
    "p2": "Account Settings",
    "p3": "How can I register an account or log in to PPPoker?",
    "p4": "You can create an account by entering a username and password, or log in via your Facebook, Google or VK account. You can also experience PPPoker via Guest Login and skip registration.",
    "p5": "How can I link my guest account?",
    "p6": "Click Profile - Settings - Link Your Email, and create an account by entering a username and password. The data for the guest account will be transferred to the new account and you will be able to log in to the game via username and password.",
    "p7": "Why does the message ‘Max. registrations reached’ appear?",
    "p8": "To maintain game stability and fairness, we have limited the number of times a player can register to our app. If you see this message, please try again later.",
    "p9": "How can I link my email?",
    "p10": "You cannot link your account to email if it’s not a username-registered account. To link your email, please go to Profile - Settings - Link Your Email, enter your email and submit the verification code received in your email.",
    "p11": "What should I do if I forget my password?",
    "p12": "If you log in using a third party account, please contact the relevant social media company support. If you use a username to log in, you can set a new password after submitting the verification code sent out to your email. Please contact info@pppoker.net for any further assistance.",
    "p13": "How can I change my password?",
    "p14": "If you log in via a third party social media account, please change it directly using the third party software. If it is a username-registered account, you can change your password in Settings. If you log in as a guest, you cannot change your password.",
    "p15": "What is the difference between a username and a nickname?",
    "p16": "Your username is your unique PPPoker identity, it is unknown to other players and cannot be changed after registration. Your nickname is an alias and is seen by other players, this can be changed multiple times.",
    "p17": "Clubs & Unions",
    "p18": "How can I create a Club?",
    "p19": "Click ‘+’ to create a Club. Non-VIP and Silver VIP users can create one Club at most, while Black and Platinum VIP users can create up to three Clubs. Each Club comes with a certain number of PP Chips for members to play.",
    "p20": "What is the difference between PP Chips and Gold?",
    "p21": "Gold can be used in the Lobby, Global Tournaments, and League sections. PP Chips can only be used in Club games. Please contact your Club Founder or Managers to get PP Chips and join the games.",
    "p22": "Gold:",
    "p23": "PP Chips:",
    "p24": "How can I find the Club ID and my User ID?",
    "p25": "View the Club ID on the homepage of the Club. You need to know a Club ID before you can join. You can find your User ID in your Profile. This unique ID cannot be changed.",
    "p26": "How can I obtain PP Chips?",
    "p27": "When there are ten or more members in your Club, you can click ‘+’ next to the PP Chips in your Club and exchange Diamonds for PP Chips.",
    "p28": "How can I approve players’ applications for membership in my Club?",
    "p29": "When new members apply for membership to a Club, there’ll be a red dot in the Member tab on the homepage of your Club. Click this to approve or reject the application in Member Details.",
    "p30": "How can I set a member as Manager or Agent?",
    "p31": "Click Member, select a member and you’ll see the options to set him/her as Manager or Agent. One member cannot be Manager and Agent at the same time.",
    "p32": "How can I set Downlines for an Agent?",
    "p33": "If the player entered an Agent ID when they applied for your Club, they will automatically becomes a downline of this Agent. If an Agent ID had not been entered, you can click Member, click on the Agent and ‘>’ to set downlines manually.",
    "p34": "How can I grant credit to an Agent?",
    "p35": "Choose Grant Credit in the Agent window and you can control PP Chips credit using the buttons Send Out and Claim Back. With PP Chips credit, Agents can send out PP Chips to their downlines.",
    "p36": "What is the difference between Founder, Manager and Agent?",
    "p37": "A Founder is the owner of a Club, who has full and final authority;",
    "p38": "A Manager enjoys the same authority as a Founder except they lack the power to disband a Club or to classify members as Managers;",
    "p39": "Agent can only manage their downlines by sending out PP Chips and checking player data.",
    "p40": "How can I upgrade my Club?",
    "p41": "Click Admin, choose Club Rating and choose the rating you'd like to upgrade to.",
    "p42": "How can I send notifications to members?",
    "p43": "Simple! Click Admin, choose Notifications, write your content and click Send.",
    "p44": "What’s the difference between Club emails and regular emails?",
    "p45": "Club emails are exclusive to their Clubs, only seen by Founders, Managers and Agents. Regular emails are seen by all players, and are more player-focused in their content.",
    "p46": "How can I join a Club?",
    "p47": "Click the Search icon on the main page and enter a Club ID. Once the Club Manager approves your application, you’ll automatically join the Club. If you join from an Agent’s referral, please enter the Agent’s ID for the convenience of club management.",
    "p48": "How can I check the my PP Chips in a Club?",
    "p49": "After joining a Club, you can see your PP Chip balance on the homepage of that Club. If the balance is less than the buy-in for a game you wish to play, please contact your Manager for more PP Chips.",
    "p50": "How can I check my Club Backpack?",
    "p51": "Find your Club Backpack in the upper right corner of the Club, and you’ll see tickets and prizes won in this Club.",
    "p52": "What is the difference between a Club and a Union?",
    "p53": "A Union comprises several Clubs. Currently, one Union allows a maximum of 20 Clubs to share tables and player pools.",
    "p54": "What are the requirements for creating or joining a Union?",
    "p55": "You can view Union Notice in the upper right corner of a Club. Currently, only Two-Star Clubs or above are able to create or join a Union. One Club can only join a maximum of one Union.",
    "p56": "How can the Union Founder suspend or remove a Club?",
    "p57": "If you have successfully created a Union which consists of multiple Clubs, you can choose to suspend or remove a Club by selecting Union - Union Members.",
    "p58": "Data Management",
    "p59": "How can I check and export Club data?",
    "p60": "Click Data in Club, and then click a game to view related detailed data.",
    "p61": "You can export data to an Excel sheet. Simply select a time period, click the EXL icon in the upper left corner, enter an email address and click Export.",
    "p62": "Trade Record and Diamond Statement can be selected when exporting data. As a Union Club you can also choose to export Union Data.",
    "p63": "How can I check the total number of PP Chips owned by Club members?",
    "p64": "Click Counter in Club, and you’ll see the total number of PP Chips owned by Club members, just as shown in the screenshot.",
    "p65": "How can I check an Agent’ credit balance?",
    "p66": "Click Member in Club, click ‘>’ next to Agent and you’ll see their credit balance in Grant Credit.",
    "p67": "How can I check my profit and loss?",
    "p68": "Click Career, select game types, game modes and time period to view detailed profit and loss.",
    "p69": "How can I check my lifetime game data?",
    "p70": "Click Data in the upper left corner in Career to view your lifetime game data.",
    "p71": "Shop",
    "p72": "How can I purchase Diamonds, Gold and VIP Cards?",
    "p73": "You can purchase Diamonds in the Shop, and purchase Gold and VIP Cards with Diamonds. You can also exchange Points for Gold and VIP Cards.",
    "p74": "What is the purpose of Gold?",
    "p75": "Use Gold to play Lobby games and join Global Tournaments. If you have extra Gold, you can also support your friends on PPPoker by sending them Gold. However, Gold cannot be exchanged for Diamonds.",
    "p76": "How can I earn Gold?",
    "p77": "Apart from exchanging Diamonds or Points for Gold, you can also earn Gold via daily logins, completing daily missions, joining time-limited events and winning Global Tournaments or Lobby games.",
    "p78": "What is the purpose of Points?",
    "p79": "Points are player rewards for being engaged with PPPoker. When you have enough Points, exchange them for prizes such as Gold, VIP Cards and more in the Points Shop. However, Points cannot be exchanged for Diamonds.",
    "p80": "Where can I earn Points?",
    "p81": "In Lobby: Points available vary by game. You can click the Points icon in the upper left corner in game to check.",
    "p82": "In Global Tournaments: Join Points events such as Points freerolls.",
    "p83": "In Club: Play various Club games to earn Points.",
    "p84": "What is the purpose of VIP Cards?",
    "p85": "VIP users enjoy up to 11 privileges which allow them a range of facilities and abilities in game.",
    "p86": "What should I do if I was charged without receiving the Diamonds I bought?",
    "p87": "Please send the payment details to us through the Feedback section in your Profile. Your Diamonds will be sent after a verification procedure.",
    "p88": "Lobby & Global Tournaments",
    "p89": "Which game types are available for play in the Lobby?",
    "p90": "No Limit Hold’em (NLH), Pot-Limit Omaha (PLO) and Open-Face Chinese Poker (OFC).",
    "p91": "What is FLASH?",
    "p92": "Flash is a new way to play No Limit Hold’em. Once you fold, you’ll immediately be dealt a new hand, at a new table and with new opponents drawn from a large player pool.",
    "p93": "What is AOF?",
    "p94": "When you play at an AOF table, you can only choose to go All-in or Fold. Each hand in this game mode grants you plenty of Points.",
    "p95": "What tournaments can I join in Global Tournaments?",
    "p96": "There are lots of events in GT, including Gold events, Points events, Ticket Satellites, KO Bounty events, VIP Card Gtd events and tournaments with mixed prizes including Gold, Points, tickets, VIP Cards and other excellent rewards.",
    "p97": "Which tournament types are available in Global Tournaments?",
    "p98": "SNG: Sit & Go tournaments start when the designated number of players are seated.",
    "p99": "MTT: Multi-Table Tournaments begin at a set time with multiple tables of players playing down to one table and finally to a winner. Top x% of players will receive prizes.",
    "p100": "Satellite: A small tournament that feeds into a larger event. You can join a larger tournament with the ticket won in a Satellite.",
    "p101": "If I don’t have enough Gold, can I take part in Global Tournaments?",
    "p102": "Sure. There are all kinds of freeroll tournaments available for you to choose from.",
    "p103": "Where can I check my prizes won in tournaments?",
    "p104": "Prizes like Gold and Points will be sent to your account directly. You can check other prizes in your Backpack, in the upper right corner in Global Tournaments.",
    "p105": "What is a Fee?",
    "p106": "In tournaments with no guaranteed prize pool, 10% of the buy-in will be charged as a fee so as to support the future operation of Global Tournaments.",
    "p107": "Hand Review & Forum",
    "p108": "Where can I check my hand history?",
    "p109": "1. Click Hand Review icon on the bottom left of a table to check your hand summary and details in text form.",
    "p110": "2. Click Profile - Hand Review to view a hand replay.",
    "p111": "How many hands can I view?",
    "p112": "1. Hand Summary:",
    "p113": "Lobby: Only the last 20 hands played at a given table are recorded.",
    "p114": "Club, Global Tournaments, League: All hands at a table are recorded until the table is disbanded.",
    "p115": "2. Hand Review:",
    "p116": "The last 100 hands are recorded in My Hands and you can add up to 50 hands in Collection.",
    "p117": "How can I save my hands?",
    "p118": "1. Click the Heart icon on the bottom left inside the Hand Review section at a table to save a hand for replay. The hand can then be found at a later date in Profile - Hand Review - Collection;",
    "p119": "2. Click Profile - Hand Review - My Hands and then click the Heart icon next to a hand to save it to Collection.",
    "p120": "How can I share my hands?",
    "p121": "1. In the Hand Summary section at a table, click the Share icon on the upper right to share a hand;",
    "p122": "2. Click the Share icon next to a hand in Profile - Hand Review - My Hands / Collection;",
    "p123": "3. If you are watching a hand reply, click the Share icon on the bottom right.",
    "p124": "What should I do if I want to replay a certain hand without adding it to Collection?",
    "p125": "If the hand was played within the last 3 months, you can send the hand ID to us via Profile - Feedback. We will be happy to help you locate it.",
    "p126": "Why are some hands missing from My Hands?",
    "p127": "Currently, Hand Replay and Collection are not available for OFC and 6+ games in Club.",
    "p128": "How can I send feedback to PPPoker if I  think there’s something wrong with a hand?",
    "p129": "1. Find the hand ID in Hand Summary and capture a screenshot of it or copy the link for the hand replay via the Share icon;",
    "p130": "2. Send the screenshot or link as well as a description to us in Profile - Feedback.",
    "p131": "How can I upload a hand replay to the Forum?",
    "p132": "1. Upload a hand to the Forum:",
    "p133": "a. Click ‘+’ in the upper right corner in the Forum;",
    "p134": "b. Select a hand;",
    "p135": "c. Click Next on the upper right;",
    "p136": "d. Add a description to the post;",
    "p137": "e. Click Send on the upper right;",
    "p138": "f. You can view the uploaded post in the Latest section of the Forum.",
    "p139": "2. Upload a hand in Hand Review:",
    "p140": "a. Click a hand in Profile - Hand Review, and then click ‘+’ on the upper right;",
    "p141": "b. Add a description to the post;",
    "p142": "c. Click Send on the upper right;",
    "p143": "d. You can view the uploaded post in the Latest section of the Forum.",
    "p144": "How can I delete my post from the Forum?",
    "p145": "Go to Forum - Mine, click the Delete icon on the upper right of a post to remove it from the Forum. (The post deleted will no longer be shown in the Forum, but you can still check the data for this hand including its comments and likes in Hand Review.)",
    "p146": "How can I view all posts made by a player in the Forum?",
    "p147": "Click a player’s avatar in the Hot or Latest sections of the Forum for access to that player’s homepage where you can view all their Forum posts.",
    "p148": "How can I add a hashtag to the post?",
    "p149": "1. Click '#hashtag' when adding a description to the post;",
    "p150": "2. Enter less than 20 characters for the hashtag or select a popular one;",
    "p151": "3. Click Confirm to create or add a hashtag;",
    "p152": "4. After posting, you can see the hashtag below the post description;",
    "p153": "5. Click the hashtag to view all posts made using this same hashtag.",
    "p154": "Push Notifications",
    "p155": "What do the push notifications include?",
    "p156": "If you enable these notifications, the following table-related notifications will be sent to you while PPPoker is running in the background or when it is closed:",
    "p157": "1. Waiting list;",
    "p158": "2. Start notifications for pre-registered MTTs;",
    "p159": "3. Game start notifications when you are waiting for a table to start in a Club;",
    "p160": "4. Notifications will be sent to offline players when Ring Games are running in Club from 8:00-10:00pm.",
    "p161": "How can I enable notifications?",
    "p162": "If you are using an iPhone, please follow the steps below:",
    "p163": "1. Tap on the Settings icon;",
    "p164": "2. Tap on Notifications;",
    "p165": "3. Click PPPoker;",
    "p166": "4. Enable Allow Notifications.",
    "p167": "If you are using an Android phone, please follow the steps below: (Steps may vary between devices)",
    "p168": "1. Tap on the Settings icon;",
    "p169": "2. Tap on Notifications;",
    "p170": "3. Click PPPoker;",
    "p171": "4. Enable Allow Notifications.",
    "p173": "Why am I not getting notifications?",
    "p174": "1. Check if you have enabled Allow Notifications for PPPoker in Settings;",
    "p175": "2. If you are using an Android phone, you may not receive notifications when PPPoker is closed. But you will still receive notifications when PPPoker is running in the background.",
    "p176": "Features",
    "p177": "How can I create a Calltime table?",
    "p178": "Managers can activate Calltime in Table Settings. When it is activated, players will be able to see the Calltime info at the table, and those who are in profit will not be able to leave the table until their calltime period ends. Currently this function is only applicable to NLH, PLO and PLO 5 Card Ring Games.",
    "p179": "How can I create a VPIP table?",
    "p180": "When creating a table, drag the VPIP slider to set the minimum value. Once it is set, players will not be able to join the table if their current Club VPIP for that game type is lower than required. Currently VPIP Settings are only applicable to NLH, PLO and PLO 5 Card Ring Games.",
    "p181": "How can I create multiple tables with one click?",
    "p182": "When creating a table, you can save the Table Settings as a template and use this template to create multiple tables with just one click. Currently you can create up to 100 tables at a time using templates.",
    "p183": "What is GPS / IP Restriction?",
    "p184": "In order to ensure that our players have a safe, secure and competitive environment for playing poker, these two functions have been introduced.",
    "p185": "GPS Restriction: If you activate this function, players in close proximity to one another will be prevented from playing at the same table.",
    "p186": "IP Restriction: If you activate this function, players with the same IP address will be prevented from playing at the same table.",
    "p187": "What are Run It Multi-Times and Insurance?",
    "p188": "These two function allow players to manage variance while playing poker. If activated, the favorite in a given hand can request to run it multiple times or buy Insurance to reduce variance when players are all-in. You can check more details in Insurance Rules on the upper left-hand Menu icon at the tables.",
    "p189": "What is the Jackpot feature?",
    "p190": "The Jackpot is a prize fund awarded to players who hit certain hands. There are two types of Jackpot: High Hand Jackpot and Cooler Jackpot. The Club Founder or Manager can set the Jackpot in the Admin section of their Club. Members can view the Jackpot details in Club Details in the upper right corner.",
    "p191": "What is Disconnect Protection?",
    "p192": "This is a feature aiming to protect players from unstable connections. Platinum VIP users will be granted a larger number of Disconnect Protections.",
    "p193": "Feedback"
  },
  "ppwc": {
    "p2": "Learn More",
    "p3": "ACTIVATE",
    "p4": "FILL IN",
    "p5": "CONFIRM",
    "p6": "FINISH",
    "p7": "PPPoker World Championship",
    "p8": "Serial Number",
    "p9": "Ticket Number",
    "p10": "Please Enter Your Serial Number",
    "p11": "Please Enter Your Ticket Number",
    "p12": "Confirm",
    "p13": "Your ticket number doesn't match your serial number.",
    "p14": "Email",
    "p15": "Please fill in the correct email address.",
    "p16": "Please make sure the name matches the ID you provide",
    "p17": "Please fill in the serial number",
    "p18": "Please fill in the email address",
    "p19": "Please fill in your name",
    "p20": "Name",
    "p21": "Please fill in the ID number",
    "p22": "ID provided already used for ticket activation",
    "p23": "ID Type",
    "p24": "Passport",
    "p25": "Identity Card",
    "p26": "Driver's License",
    "p27": "ID Number",
    "p28": "Nationality",
    "p29": "Country",
    "p30": "Please choose your nationality.",
    "p31": "Cancel",
    "p32": "Done",
    "p33": "Date of Birth",
    "p34": "Date",
    "p35": "Please fill in your date of birth.",
    "p36": "Please read the {link}",
    "p37": "User Agreement",
    "p38": "Preferred Flight",
    "p39": "Please choose your preferred flight",
    "p40": "Day 1a",
    "p41": "Day 1b",
    "p42": "Day 1c",
    "p43": "Fast Day 1d",
    "p44": "Day 1e",
    "p45": "Fast Day 1f",
    "p46": "Please read the {link}",
    "p47": "Privacy Policy",
    "p48": "Please confirm that all the information is correct.",
    "p49": "Return",
    "p50": "Your ticket has been activated! A confirmation email with attached event information will be sent out to you shortly.",
    "p51": "For Customer Service:",
    "p52": "Please contact: {link}",
    "p53": "For Live Events:",
    "p54": "Please contact: {link}",
    "p56": "Dear Player,\r\n\r\nCongratulations, you have successfully activated your PPWC Main Event Ticket!",
    "p57": "Please see below the information which you have registered to your ticket:",
    "p58": "Please note that PPWC Main Event e-tickets are non-refundable and non-transferrable once activated. You must bring a valid passport or government ID with you when you register on site.",
    "p59": "PPWC Brazil will run from April 21st - 28th, 2020, at the Holiday Inn, Sao Paulo. The Main Event is set to be one of the largest live poker events ever run in Latin America and features a massive R$ 4 million guarantee for only a buy-in of just R$1,250!",
    "p60": "Attached you can find the full schedule for PPWC Brazil and the Main Event structure. ",
    "p61": "We look forward to seeing you at PPWC Brazil!",
    "p62": "If you need assistance with your activated Main Event ticket, please contact [info@pppoker.net]. For more information, please contact [events@pppoker.net] or visit our official website: [insert PPWC Link]",
    "p63": "PPPoker - By Poker Lovers, For Poker Lovers!",
    "p64": "Best Regards,",
    "p65": "the PPWC Operations Team",
    "p66": "Persons under the age of 18 are not allowed to activate any electornic ticket and/or participate in the PPPoker World Championship 2020.",
    "p67": "Notice",
    "p68": "Please select",
    "p69": "Persons under the age of 18 are not allowed to activate any electornic ticket and/or participate in the PPPoker World Championship 2020.",
    "p70": "Failed. You do not meet the minimum age requirement.",
    "p71": "You have already activated the ticket. Look forward to seeing you in Sao Paulo Brazil.",
    "p72": "PPWC BRAZIL 2020",
    "p73": "PPPoker World Championship",
    "p74": "Event Dates: ",
    "p75": "Location: ",
    "p76": "PPPoker is making poker history in Brazil, with plans for the largest live tournament ever run in the country! ",
    "p77": "The PPWC Main Event features an eye-watering guaranteed prize pool that is set to break Brazilian poker records, with a low buy-in/high guarantee promise, it is sure to be gigantic!",
    "p78": "Come and join this huge Latin poker extravaganza!",
    "p79": "Key Dates & Tournament Schedule",
    "p80": "Please see below for PPWC Brazil's key tournaments:",
    "p81": "PPWC Team Event",
    "p82": "PPWC Main Event",
    "p83": "Ladies' Event",
    "p84": "PPWC High-Roller",
    "p85": "The full schedule can be found {link}.",
    "p86": "here",
    "p87": "All Tournaments are Unlimited Re-entry (Unless specified otherwise) ",
    "p88": "Stack Surrender (Less than starting stack)",
    "p89": "Last 3 Hands for All Tournaments for Last Level Registration",
    "p90": "PPWC Rules Apply",
    "p91": "PPPoker Online Qualifier* Benefits",
    "p92": "Main Event Last Player Standing Package – The last PPPoker online qualifier to be knocked out of the Main Event can get a bonus prize! – R$ 100,000 PPPoker Grand Passport Package.",
    "p93": "The PPWC Main Event Day 1a chip leader will win a R$ 15,000 PPPoker Passport Package (valid for 12 months).",
    "p94": "The PPWC Main Event Day 1b chip leader will win a R$ 10,000 PPPoker Passport Package (valid for 12 months).",
    "p95": "*This promotion is open to PPPoker account online qualifiers only.",
    "p96": "Online Satellites",
    "p97": "Each player must have a PPPoker account to participate in any PPPoker online satellites. For enquiry, please contact {link}.",
    "p98": "The Venue",
    "p99": "PPWC Brazil will be held at the Holiday Inn São Paulo, Brazil.",
    "p100": "Address: Rua Professor Milton Rodriguez #100 - Parque Anhembi, São Paulo - SP, 02009-040, Brazil.",
    "p101": "ID Requirement: All players must bring an official identity document with a photo included to participate, such as a valid passport, driving license, or ID card.",
    "p102": "Accommodation",
    "p103": "Located right next to the Campo de Marte Airport, the Holiday Inn® São Paulo Parque Anhembi hotel is the best option whether travelling for business or pleasure. This hotel near the Centro de Convenções Anhembi offers a free shuttle service to the Tietê metro station and the Shopping Expo Center Norte.",
    "p104": "Event Cancelled",
    "p105": "Holiday Inn São Paulo, Brazil",
    "p106": "Preferred Fight (Choice Not Guaranteed)",
    "p107": "PPPoker E-Ticket Holder* Benefits",
    "p108": "Main Event Last Player Standing Package – The last PPPoker e-ticket holder to be knocked out of the Main Event will win a PPPoker Grand Package worth R$ 100,000 (valid for 12 months).",
    "p109": "If you are an e-ticket holder and become the PPWC Main Event Day 1a chip leader, you will win a PPPoker Grand Package worth R$ 15,000 (valid for 12 months).",
    "p110": "If you are an e-ticket holder and become the PPWC Main Event Day 1b chip leader, you will win a PPPoker Grand Package worth R$ 10,000 (valid for 12 months).",
    "p111": "Your last chance of obtaining an e-ticket will be on 14th April 2020. Come and join us now!",
    "p112": "*This promotion is open to the PPWC Brazil 2020 Main Event e-ticket holders only and all prizes must be claimed on or before 29th April 2020."
  }
}
